import { HOUSEHOLD_MEMBER_AVATARS } from '../caremap/CareMapFactory';
import { CareMapState } from '../caremap/CareMapState';

export class DefaultAvatarProvider {
    getDefaultAvatar = ({ careMap, inUse = [] }: { careMap: CareMapState; inUse?: string[]; }): string => {
        const state = careMap.getActiveCaremap();

        const avatarsInUse = [
            ...inUse,
            state?.patient.avatar,
            ...(state?.household.members || []).map(mem => mem.avatar)
        ];

        const unusedAvatars = HOUSEHOLD_MEMBER_AVATARS.filter(a => !avatarsInUse.includes(a));

        return unusedAvatars[0] || HOUSEHOLD_MEMBER_AVATARS[0];
    };
}
